import { render, staticRenderFns } from "./ItemAdminGeneralOrganization.vue?vue&type=template&id=22e28cae&"
import script from "./ItemAdminGeneralOrganization.vue?vue&type=script&lang=js&"
export * from "./ItemAdminGeneralOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports